import * as React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "../lib/utils";

// Single standard "Loading..." surface. Replaces a dozen hand-rolled
// `flex items-center justify-center py-24` blocks with varying spinner
// sizes, spacing, and whether or not a label was shown.
//
// Default is label-less because most consumers want the spinner only;
// pass `label` when the wait is expected to be noticeable (> ~500ms)
// and the user benefits from knowing what is loading.

interface LoadingStateProps {
  label?: string;
  /** Vertical padding. Defaults to `py-16` (a typical card body). */
  className?: string;
  size?: "sm" | "md" | "lg";
}

export function LoadingState({ label, className, size = "md" }: LoadingStateProps) {
  const spinnerSize =
    size === "sm" ? "h-4 w-4" : size === "lg" ? "h-8 w-8" : "h-6 w-6";
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 py-16 text-muted-foreground",
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <Loader2 className={cn("animate-spin", spinnerSize)} />
      {label && <p className="text-xs">{label}</p>}
    </div>
  );
}
